import { useMemo } from 'react';
import { useRowSelection } from '../../contexts/RowSelectionContext';
import { AssetRowDescriptor } from '../table/hooks/useAssetsTable';
import { Text } from '@mantine/core';

export function SelectionCounter() {
  const { rowSelection } = useRowSelection();
  const [sourcesCount, outputsCount] = useMemo(() => {
    const selected = Object.keys(rowSelection).map((row) => JSON.parse(row) as AssetRowDescriptor);
    return [selected.filter((s) => s.type === 'raw').length, selected.filter((s) => s.type === 'output').length];
  }, [rowSelection]);

  return (
    <Text mr='xs' ta='right'>
      You have selected {sourcesCount} source {singularPluralModel(sourcesCount)} and {outputsCount} output{' '}
      {singularPluralModel(outputsCount)}.
    </Text>
  );
}

function singularPluralModel(count: number) {
  return count === 1 ? 'model' : 'models';
}
